<!-- eslint-disable max-len -->
<template>
  <div
    v-if="isLoading"
    class="d-flex align-items-center justify-content-center"
    style="height: 400px">
    <div class="lds-ellipsis"><div/><div/><div/><div/></div>
  </div>

  <div
    v-else
    class="row form-page-detail--body">
    <b-col cols="12">
      <div class="section-container">
        <h6 class="font-weight-bold">Model</h6>
        <b-row
          v-for="(item, index) in dataModel"
          :key="index"
          class="content-model-ai">
          <b-col md="1">
            <b-img
              :src="require('@/assets/icon/model-default.png')"
              rounded="circle"
              alt="img"
              class="m-1 round-bordered-img img-circle"/>
          </b-col>
          <b-col
            md="9"
            class="border-bottom">
            <div class="label-1">Jojonomic</div>
            <div class="label-2">{{ item.model_name }}</div>
            <div class="label-3">
              <b-img :src="require('@/assets/icon/ai-id.png')"/>
              {{ item.id }}
              <span class="m__l--10">{{ getDuration(item.updated_at) }}</span>
            </div>
          </b-col>
          <b-col
            md="2"
            class="border-bottom">
            <div class="label-status">{{ item.status.toUpperCase() }}</div>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </div>
</template>

<script>
/* eslint-disable max-len, no-nested-ternary, no-console, camelcase, no-unused-vars, no-mixed-operators */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';

export default {
  components: {
  },
  validations() {
    const validate = {};
    return validate;
  },
  props: {
    aiDetail: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: true,
      dataModel: null,
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },
  computed: {
    ...mapState('jStoreAi', ['train_created']),
  },
  watch: {
    train_created() {
      this.getDataModelAi();
    },
  },
  created() {
    this.getDataModelAi();
  },
  methods: {
    ...mapActions('jStoreAi', ['getModelAi']),

    getDataModelAi() {
      this.isLoading = true;
      const params = {
        ai_id: this.aiDetail.id,
      };
      this.getModelAi(params).then((res) => {
        this.isLoading = false;
        this.dataModel = res.data;
      });
    },

    getDuration(input) {
      const date = new Date();
      const duration = date.getTime() - input;
      const dur = this.$moment.duration(duration);
      const hours = Math.floor(dur.asHours());
      const mins = Math.floor(dur.asMinutes()) - hours * 60;
      const sec = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60;
      const result = `${hours} hours ago`;
      return result;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/ai/menu/jMenuModel.vue